import {Injectable, signal} from '@angular/core';

export type FlashAlertState = {
  title?: string;
  message?: string;
  type: 'success' | 'info' | 'danger' | 'warning'
  isDismissible?: boolean
}

const INITIAL_STATE: FlashAlertState = {type: 'danger', title: undefined, message: undefined};
@Injectable({
  providedIn: 'root'
})
export class FlashAlertService {

  private state = signal<FlashAlertState>(INITIAL_STATE)

  setState(state: FlashAlertState) {
    this.state.set(INITIAL_STATE);

    setTimeout(()=> {
      this.state.set(state);
    },50)

    return this;
  }

  getState() {
   return this.state.asReadonly();
  }

}
